<div class="page">
  <div class="page__container">
    <h1 class="page__title h2">{{ 'shop_purchase_title' | translate }}</h1>
    <div class="row mt-5">
      <div class="col-12 mb-4">
        <div class="toastr-relative toastr-sm toastr-no-shadow mb-1" toastContainer></div>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-12 mb-4">
        <wsb-atlas-button variant="tertiary"  class="mb-2" [label]="'shop_purchase_gotodashboard'" routerLink="/">{{ 'shop_purchase_gotodashboard' | translate }}</wsb-atlas-button>
      </div>
    </div>
  </div>
</div>
